import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// This config is ONLY for local development with emulators. It's safe.
const devConfig = {
  apiKey: "emulator-key",
  authDomain: "localhost",
  projectId: "odi-logistics-app", // Must match your project ID
  storageBucket: "default-bucket",
};

// This config is for your deployed PRODUCTION app.
// It reads the keys from the .env.local file you created.
const prodConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Check if we are in a local development environment (when you run `npm start`)
const isLocal = process.env.NODE_ENV === 'development';

// Use the appropriate config
const firebaseConfig = isLocal ? devConfig : prodConfig;

// Initialize Firebase with the correct config
const app = initializeApp(firebaseConfig);

// Get references to the services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// If we are in local development, connect to the emulators
if (isLocal) {
  console.log("🔥 Development mode: Connecting to local emulators...");
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
    console.log("✅ Emulators connected successfully.");
  } catch (error) {
    console.error("⚠️ Error connecting to emulators:", error);
  }
} else {
  console.log("🌍 Production mode: Connecting to live Firebase services.");
}

export { auth, db, storage, app };